import React from 'react';
import { useRouteError } from 'react-router-dom';
import { FeatureLoadError } from './FeatureLoadError';
import { LoadingSpinner } from './LoadingSpinner';
import { isChunkLoadError, reloadOnceForChunkError } from '../utils/chunkLoadError';

export const RootErrorElement: React.FC = () => {
  const error = useRouteError();

  if (reloadOnceForChunkError(error)) {
    return <LoadingSpinner />;
  }

  const message = isChunkLoadError(error)
    ? 'We could not load this part of the app. This is usually a temporary network issue or a new version being released.'
    : 'Something went wrong while loading this page.';

  return <FeatureLoadError error={message} onRetry={() => window.location.reload()} />;
};
